import { render, staticRenderFns } from "./SeoAssessor.vue?vue&type=template&id=a6678b8c&"
import script from "./SeoAssessor.vue?vue&type=script&lang=js&"
export * from "./SeoAssessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports